// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

export default class ViewPanel extends Component {
  activeClass: string = 'panel__view--active';
  id: string;

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.id = this.el.dataset.id;

    this.addListener(Notifications.TOGGLE_VIEW_PANEL, this.toggle);
    this.addListener(Notifications.CLEAR_VIEW_PANEL, this.close);
  }

  /**
   * Toggle the panel visible or invisible
   */
  toggle({ id }: { id: string }): void {
    if (!id) {
      throw new Error('the id should be specified to be able to open a panel');
    }
    if (id === this.id) {
      if (this.el.classList.contains('hidden')) {
        this.show();
      } else {
        this.hide();
      }

      if (window.store.activeViewPanels.contains(this.id)) {
        window.store.activeViewPanels.delete(this.id);
      } else {
        window.store.activeViewPanels.add(this.id);
      }
    }

    this.handleScrollClass();
  }

  /**
   * Show the panel with transition
   */
  show(): void {
    this.el.classList.remove('hidden');
    setTimeout(() => {
      this.el.classList.add(this.activeClass);
    }, 0);
  }

  /**
   * Hide the panel with transition
   */
  hide(): void {
    this.el.classList.remove(this.activeClass);
    setTimeout(() => {
      this.el.classList.add('hidden');
    }, 300);
  }

  /**
   * Close the panel with X
   */
  close(): void {
    window.store.activeViewPanels.delete(this.id);
    this.hide();
    this.handleScrollClass();
  }

  /**
   * Sets a no-scroll class to html when there is an active view panel
   */
  handleScrollClass(): void {
    if (window.store.activeViewPanels.count()) {
      this.notify(Notifications.DISALLOW_SCROLLBAR);
      return;
    }
    this.notify(Notifications.ALLOW_SCROLLBAR);
  }
}
